import { createSvgIcon } from "@mui/material";

const DashedArrowRightIcon = createSvgIcon(
  <svg viewBox="0 0 61 10" fill="none">
    <path
      d="M1 4.25C0.585786 4.25 0.25 4.58579 0.25 5C0.25 5.41421 0.585786 5.75 1 5.75V4.25ZM61 5L53.5 0.669873V9.33013L61 5ZM1 5V5.75H3.14286V5V4.25H1V5ZM7.42857 5V5.75H11.7143V5V4.25H7.42857V5ZM16 5V5.75H20.2857V5V4.25H16V5ZM24.5714 5V5.75H28.8571V5V4.25H24.5714V5ZM33.1429 5V5.75H37.4286V5V4.25H33.1429V5ZM41.7143 5V5.75H46V5V4.25H41.7143V5ZM50.2857 5V5.75H54.5714V5V4.25H50.2857V5ZM1 4.25C0.585786 4.25 0.25 4.58579 0.25 5C0.25 5.41421 0.585786 5.75 1 5.75V4.25ZM61 5L53.5 0.669873V9.33013L61 5ZM1 5V5.75H3.14286V5V4.25H1V5ZM7.42857 5V5.75H11.7143V5V4.25H7.42857V5ZM16 5V5.75H20.2857V5V4.25H16V5ZM24.5714 5V5.75H28.8571V5V4.25H24.5714V5ZM33.1429 5V5.75H37.4286V5V4.25H33.1429V5ZM41.7143 5V5.75H46V5V4.25H41.7143V5ZM50.2857 5V5.75H54.5714V5V4.25H50.2857V5Z"
      fill="currentColor"
    />
  </svg>,
  "DashedArrowIconRight"
);

export default DashedArrowRightIcon;
